import { ComponentProps } from "react";
import { Dialog, styled, Text, View, ViewProps } from "tamagui";

const ControllArea: React.FC<ViewProps> = ({ children, ...rest }) => {
  return (
    <View
      backgroundColor={"$gray-50"}
      borderBottomRightRadius={"$5"}
      borderBottomLeftRadius={"$5"}
      borderTopWidth={"$0.2"}
      borderTopColor={"$gray-200"}
      {...rest}
    >
      {children}
    </View>
  );
};

const Content = styled(Dialog.Content, {
  name: "GeneralDialogContent",
  borderRadius: "$9",
  backgroundColor: "white",
  padding: 0,
});

const Close: React.FC<ComponentProps<typeof Dialog.Close>> = ({
  children,
  ...rest
}) => {
  return (
    <Dialog.Close cursor="pointer" padding={0} {...rest}>
      <Text
        fontFamily={"$body"}
        fontWeight={"$5"}
        fontSize={"$3"}
        lineHeight={"$3"}
      >
        {children}
      </Text>
    </Dialog.Close>
  );
};

const Title = styled(Dialog.Title, {
  name: "GeneralDialogTitle",
  fontFamily: "$subtitle",
  fontWeight: "$6",
  fontSize: "$6",
  lineHeight: "$6",
  textAlign: "center",
  color: "$gray-950",
});

const Overlay = styled(Dialog.Overlay, {
  name: "GeneralDialogOverlay",
  backgroundColor: "#6A696966",
  backdropFilter: "blur(10px)",
  alignItems: "center",
  justifyContent: "center",
});

export const GeneralDialog = {
  ControllArea,
  Content,
  Close,
  Title,
  Overlay,
};
